module.exports = __webpack_public_path__ + "img/capa-hover.ef3e248a.png";